<template>
  <el-dialog :class="[currentTheme]" v-dialogDrag:{dialogDrag}=true :title="dialogName" :visible.sync="dialogVisible" :width="dialogWith" :height="dialogHeight" :close-on-click-modal="false" @close='handleCloseDialog' append-to-body>
    <div class="dialog-main">
      <el-upload
        ref="xrUpload"
        class="upload-demo"
        multiple
        drag
        :accept="accept"
        :on-success="fileUploadSuccess"
        :on-error="fileUploadError"
        :data="paramsObj"
        :limit="limit"
        :file-list="fileList"
        :action="uploadUrl">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">{{tip}}</div>
      </el-upload>
      <div class="upload-btn" @click="submit()">确定</div>
    </div>
  </el-dialog>
</template>

<script>
  import { getToken } from '@/utils/auth'


  export default {
    name: "pageSelectDialog",
    props: {
      type: String,
      businessType: String,
      //允许的文件类型
      accept: {
        type: String,
        default: '.png,.jpg,.JPEG,.xls,.xlsx,.csv,.docx,.doc,.pdf'
      },
      //关联的业务ID
      targetId: {
        // type: String,
        default: ''
      },
      //上传后关闭
      onUploadedClose: {
        type: Boolean,
        default: false
      },
      //限制数
      limit: {
        type: Number,
        default: 99
      },
      //文件名
      fileName: {
        // type: String,
        default: ''
      },

      //备注
      tip: {
        type: String,
        default: ''
      },
    },
    data (){
      return {
        dialogVisible: false,
        fileList: [],                                                        //文件列表
        uploadUrl: process.env.FILE_URL + "/fileWeb/uploadResource",
        paramsObj: new Object(),
        dialogName: '上传文件',
        dialogWith: '400px',
        dialogHeight: '800px',
      }
    },
    computed: {
      currentTheme() {
        return this.$store.getters.themeType; //获取当前的主题类型
      },
    },
    components: {

    },
    created() {
      this.paramsObj['accessToken'] = getToken();
    },
    methods: {
      init() {
        this.dialogVisible = true;
        this.fileList = [];
        if(!!this.targetId){
          this.paramsObj['targetId'] = this.targetId;
        }
        if(!!this.businessType){
          this.paramsObj['businessType'] = this.businessType;
        }
        if(!!this.fileName){
          this.paramsObj['fileName'] = this.fileName;
        }
      },
      //关闭窗口
      handleCloseDialog(){
        this.dialogVisible = false;
      },
      //上传成功后的操作
      fileUploadSuccess(response){
        console.log('response-------------------------------')
        console.log(response)
        //判断文件格式
        let fileName = ''
        let data = false
        if (!!response.fileName){
          fileName = response.fileName;
        }else if (!!response.data.fileName){
          data = true
          fileName = response.data.fileName;
        }else{
          fileName = undefined;
        }
        let suffix = this.getSuffix(fileName)
        if(!!this.accept){
          if(!this.accept.includes(suffix)){
            this.$message.error("请选择正确的文件格式！");
            return false
          }
        }
        // 如果返回编码不为0，提示失败语
        if(response.code != '0'){
          this.$refs.xrUpload.uploadFiles = this.fileList;
          this.$message.error(response.msg);
          return false;
        }
        this.fileList = this.$refs.xrUpload.uploadFiles;
        if(this.onUploadedClose){  //如果上传后关闭开启后
          if (data){
            this.saveData(response.data)
          }else{
            this.submit();
          }
          this.handleCloseDialog();
        }
      },
      //上传失败后的操作
      fileUploadError(e){

      },
      //保存
      submit(){
        console.log('submit')
        let ids = '';
        let list = [];
        for(let i = 0; i < this.fileList.length; i ++){
            let response = this.fileList[i].response;
            if(response == null || response == '' || response == undefined){
                continue;
            }
            let id = this.fileList[i].response.resourceId;
            let obj = new Object();

            obj.id = id;
            obj.name = this.fileList[i].name;
            obj.fileName = response.fileName
            obj.url = this.fileList[i].response.resAddr;
            list.push(obj);
            if(ids == ''){
              ids = id;
            }else{
              ids += ',' + id;
            }
        }
        console.log(this.fileList)
        console.log(ids)
        console.log(list)
        this.$emit('confirmMethod',list);
        this.dialogVisible = false;
      },
      // 保存2 如果有data的话 返回data
      saveData(data){
        console.log('saveData')
        this.$emit('confirmMethod',data);
        this.dialogVisible = false;
      },
      //获取文件后缀
      getSuffix(string){
        if(string){
          let lastIndex = string.lastIndexOf('.');
          return '.' + string.substring(lastIndex+1);
        }else{
          return false;
        }
      },
    }
  }
</script>
<style>
  .upload-demo{
    text-align: center;
  }
  .upload-btn{
    margin-top: 10px;
    width: 100%;
    background: #007aff;
    color: #fff;
    padding: 4px 10px;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/XrUpload/index.vue